export const initialState = {
    user: null,
    dicts: null,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'USER_LOADED':
            localStorage.setItem('sessionId', action.payload?.sessionId ?? '');
            return {
                ...state,
                user: action.payload,
                dicts: action.payload ? state.dicts : null,
            };
        case 'DICTS_LOADED':
            return {
                ...state,
                dicts: action.payload,
            };
        default:
            return state;
    }
};
